
import React from 'react';
import { ReadingDay2026 } from '../views';


const RentalPage = () => {
  return <ReadingDay2026/>;
};

export default RentalPage;
